import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useGetBlogsEffect } from '../../../state';

export const useBlogsPostsEffect = () => {
  const router = useRouter();

  const getBlogs = useGetBlogsEffect();

  const [currentShow, setShow] = useState<boolean>(false);

  const changeTag = (tag: string) => {
    router.push(tag === 'all' ? '/blogs/posts' : `/blogs/posts/tagged/${tag}`);
  };

  const viewArticle = (handle: string) => {
    router.push(`/blogs/posts/${handle}`);
  };

  useEffect(() => {
    if (
      !getBlogs.loading &&
      typeof getBlogs.data === 'undefined' &&
      typeof getBlogs.success === 'undefined' &&
      typeof getBlogs.error === 'undefined'
    ) {
      getBlogs.do();
    }
  }, [getBlogs]);

  return {
    blogs: getBlogs.data,
    loading: getBlogs.loading,
    changeTag,
    viewArticle,
    currentShow,
    setShow,
  };
};
